



































































import Vue from "vue";
import { State, Action, Mutation } from "vuex-class";
import Component from "vue-class-component";
import { FacebookState } from "../../../store/facebook";
const namespace = "facebook";

@Component
export default class Advideos extends Vue {
  @State("facebook") facebook: FacebookState;
  @Action("fetchAdvideos", { namespace }) fetchAdvideos: any;
  @Action("checkAdStatuses", { namespace }) checkAdStatuses: any;
  @Action("deleteAdCreative", { namespace }) deleteAdCreative: any;
  @Mutation("selectAdvideo", { namespace }) selectAdvideo: any;

  title = "";
  loading = false;
  headers = [
    { text: "Preview", value: "preview", sortable: false },
    { text: "Name", value: "title", sortable: false },
    { text: "Select", value: "select", sortable: false },
    { text: "Status", value: "status", sortable: false }
  ];

  deleteTarget: any = null;

  showDeletePopup = false;
  deletingAd = false;

  beforeRouteUpdate(to: any, from: any, next: Function) {
    this.fetch({ accountId: to.params.accountId });
    next();
  }
  fetch({ accountId, title }: { accountId: string; title?: string }) {
    if (!title) return;
    this.loading = true;
    this.fetchAdvideos({ accountId, title })
      .then(() => {
        this.loading = false;
      })
      .then(async () => {
        this.checkAdStatuses({
          accountId,
          videos: this.facebook.advideos
        });
      });
  }

  handleDeleteAd() {
    this.deletingAd = true;
    this.deleteAdCreative({
      accountId: this.$route.params.accountId,
      adId: this.deleteTarget?.id
    }).then(() => {
      this.deletingAd = false;
      this.deleteTarget = null;
      this.fetch({
        accountId: this.$route.params.accountId,
        title: this.title
      });
    });
  }

  setDeleteTarget(item: any) {
    this.deleteTarget = item;
  }

  mounted() {
    this.fetch({ accountId: this.$route.params.accountId });
  }
  // computed variable based on user's email
}
